import { useState } from "react";

const useSortPriceCalc = formikItemDetail => {
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");
  const handleSort = () => {
    const lines = [...formikItemDetail.values.lines];

    if (sortDirection === "desc") {
      lines.sort((itemA, itemB) => Number(itemA.itemNo) - Number(itemB.itemNo));
      setSortDirection("asc");
    } else {
      lines.sort((itemA, itemB) => Number(itemB.itemNo) - Number(itemA.itemNo));
      setSortDirection("desc");
    }

    formikItemDetail.setFieldValue("lines", lines);
  };

  return { handleSort, sortDirection };
};

export default useSortPriceCalc;
